export default "__VITE_ASSET__74afdefb__"